const availableFormats = ['pdf'];

export const matchFileFormat = value => {
  if (value) {
    const name = value.name.toLowerCase();
    const fileFormat = name.split('.').pop();
    return availableFormats.includes(fileFormat);
  }

  return true;
};
